import './phone-number-input.scss';

import { ReactComponent as ArrowIcon } from '../../assets/icons/arrow-sort.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode } from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

const CustomCountrySelect = ({ value, onChange, options, iconComponent: Icon }) => {
  const callingCode = value ? getCountryCallingCode(value) : '';
  const countryName = options?.find((o) => o.value === value)?.label || '';

  return (
    <div className="phone-number-input__country">
      <select
        className="phone-number-input__country-select"
        value={value || ''}
        onChange={(event) => onChange(event.target.value || undefined)}>
        {options.map((option) => (
          <option key={option.value || 'empty'} value={option.value || ''}>
            {option.label}
          </option>
        ))}
      </select>

      {value && Icon && (
        <div className="phone-number-input__flag">
          <Icon country={value} label={countryName} />
        </div>
      )}

      {value && <span className="phone-number-input__calling-code">+{callingCode}</span>}

      <ArrowIcon />
    </div>
  );
};

CustomCountrySelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array,
  iconComponent: PropTypes.elementType
};

export const PhoneNumberInput = ({ label, control, error }) => {
  return (
    <div className="form__item phone-number-input">
      {label && <label className="form__label">{label}</label>}
      <Controller
        name="phone_number"
        control={control}
        rules={{
          validate: (value) => isValidPhoneNumber(value)
        }}
        render={({ field: { onChange, value } }) => (
          <div
            className={classNames('phone-number-input__wrapper', {
              'phone-number-input__wrapper--error': error
            })}>
            <PhoneInput
              value={value}
              onChange={onChange}
              placeholder="Enter phone number"
              defaultCountry="NG"
              flags={flags}
              countrySelectComponent={CustomCountrySelect}
              className="phone-input-custom"
            />
          </div>
        )}
      />
      {error && (
        <span role="status" className="form__error">
          {error}
        </span>
      )}
    </div>
  );
};

PhoneNumberInput.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  control: PropTypes.object
};
